const _excluded = ["variant", "size", "onClick"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import Button from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';
const ClearButton = _ref => {
  let {
      variant = Button.VARIANTS.TERTIARY,
      size = Button.SIZES.SMALL,
      onClick
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("../i18n/".concat(locale, ".json"));
  });
  return /*#__PURE__*/React.createElement(Button, _extends({
    variant: variant,
    size: size,
    onClick: onClick
  }, props), T.translate('CLEAR'));
};
ClearButton.displayName = 'ClearButton';
export default ClearButton;
//# sourceMappingURL=ClearButton.js.map